<template lang="pug">
  div.upper-subpanel--inside(v-if="systemShowed")
    div.btn-system-change#prev-system(
      @click="previousSystem"
      v-if="systemIndex > 0"
    )
    //- dirty hack for force re-rendering
    span(style="display: none") {{selectedDevicesID}}
    span(style="display: none") {{selectedDrugInDeviceID}}


    div.system-wrapper
      div.one-system
        p.text-center(style="margin-top: 0px;margin-bottom: 5px;") 
          strong 藥櫃編號: {{ systemShowed.relative_index }}
        div.net-wrap
          div(
            :class="{ 'one-net': true, 'selected': net_key === (currentNet.row_id - 1) }" 
            v-for="(net, net_key) in systemShowed.net_set" 
            @click="selectNet(net)" 
            :id="'net-' + net_key"
          ) {{ net.row_id }} - {{ net.type }}
            span.device-badge(
                v-if="net.hasDeviceSelected"
            ) 
            span.btn.btn-select(@click.stop="selecteAllDrugStorageWithNet(net)" v-if="mode === 'onlyDrug'") 選擇整層

        transition(name="fade")
          div.row-model(v-show="showRow")
            div.model-mask(@click="showRow = !showRow")
            div.row-wrap
              div.row-info
                span 第 {{currentNet.row_id}} 層
                //- div.btn.btn-primary 選擇全部
              //- if the drawer type is A.
              div.one-net-row(
                v-for="n in numRow"
                :style="{'height':  100/numRow + '%', order: n}"
              )
                div(
                  :class="{ 'one-device': true, 'selected-arise': device.selected, \
                    'return-cmpn': device.specific_type === 'return_device', \
                    'lock-cmpn': device.specific_type === 'lock_device', \
                    'lock-cmpn-full': (device.specific_type === 'lock_device' && device.drugstorage_set.length > 0), \
                    'device-in-F': currentNet.type === 'F'}"
                  v-for="device in currentNet.device_set"
                  v-if="device.pos_row === n || currentNet.type === 'F'"
                  @click="selectDevice(device)" 
                  :id="`device-${device.pos_row}-${device.relative_col}`"
                  :style="{'width': (100*(device.width/6)) + '%' }"
                )
                  //- span {{ device.id }}

                  span.device-position {{ device.pos_row }} - {{ device.relative_col }}
                  div.drug-pop(v-if="device.drugstorage_set !== ''") 
                    span(v-if="device.specific_type == 'return_device'") 退藥盒
                    span(v-else-if="device.specific_type == 'lock_device'") 保管盒
                    div.device-drug(:class="{ 'selected': storage.selected, 'expired': storage.expired }"
                      @click.stop="selectDrug(storage)"
                      v-else
                      v-for="storage in device.drugstorage_set")
                      //- img(src="/static/svg/round-drugs.svg")
                      span {{ storage.medication.code }} / {{ storage.medication.CGMH_number}}
                      span {{ storage.medication.generic_name | setLength }}
                      span(v-if="storage.expired") 已過期
                      span(v-else)
                        small {{ storage.expired_date }}
                  div.error-device-mask(v-if="device.error")
                    p 藥盒已鎖定
                      //- span {{ storage.id }}
              //- div.btn.control-button-red.pos-confirm-button(
              //-   @click="showRow = !showRow"
              //- ) 確定
        //- p.text-center(style="margin-top: 10px;margin-bottom: 0;") {{ currentSystem.name }}
        div.cabinet-bottom-wrap
          div.cabinet-bottom.float-left
          div.cabinet-bottom.float-right
    div.btn-system-change#next-system(
      v-if="systemIndex + 1 < systemIds.length"
      @click="nextSystem"
    )
  Loader(v-else)
    
</template>

<script>
// TODO: singleSelectionMode.
// mode: onlyDrug, emptyAndF

import _ from 'lodash';
import Loader from '../common/Loader';

export default {
  name: 'PositionSelection',
  props: {
    mode: {
      type: String,
      default: 'onlyDrug',
    },
    singleSelect: {  // currently used on setting return box.
      type: Boolean,
      default: false,
    },
  },
  components: {
    Loader,
  },
  data() {
    return {
      selectedDevice: {},
      showRow: false,
      allSystems: {},
      systemIds: [],
      systemIndex: 0,
      currentNetIndex: 0,
      previousSelectedDevicesID: [],
      previousSelectedDrugStorageID: [],
    };
  },
  created() {
    // this.$store.commit('SET_CURRENT_SYSTEM', this.currentSystemIndex);
    // this.$store.commit('SET_CURRENT_NET', 0);
    this.allSystems = this.$store.state.device.systems;
    this.systemIds = Object.keys(this.allSystems);
  },
  computed: {
    currentNet() {
      return this.systemShowed.net_set[this.currentNetIndex];
    },
    // allSystems() {
    //   return this.$store.getters.systems;
    // },
    // currentNetIndex() {
    //   return this.$store.getters.currentNetIndex;
    // },
    systemShowed() {
      return this.allSystems[this.systemIds[this.systemIndex]];
    },
    numRow() {
      let row = 1;
      this.currentNet.device_set.forEach((device) => {
        if (device.pos_row > row) row = device.pos_row;
      });
      return row;
    },
    selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    selectedDrugInDeviceID() {
      return this.$store.getters.selectedDrugInDeviceID;
    },
  },
  methods: {
    selectNet(net) {
      let netDrugStorageCount = 0;
      net.device_set.forEach((device) => {
        netDrugStorageCount += device.drugstorage_set.length;
      });

      this.currentNetIndex = (net.row_id - 1);
      this.showRow = !this.showRow;
    },
    selecteAllDrugStorageWithNet(net) {
      net.device_set.forEach((device) => {
        if (device.drugstorage_set.length >= 0) {
          try {
            device.drugstorage_set.forEach((item) => {
              this.selectDrug(item);
            });
          } catch (err) {
            console.log(err);
          }
        }
      });
    },
    selectDevice(device) {
      if (this.singleSelect) this.$store.dispatch('emptyDevices');

      if (this.mode === 'onlyDrug' && device.error !== true) {
        if (device.drugstorage_set.length >= 1 && device.specific_type !== 'return_device') {
          let drugStorageAllExpired = true;
          device.drugstorage_set.forEach((drugstorage) => {
            if (drugstorage.expired === false) drugStorageAllExpired = false;
          });
          if (drugStorageAllExpired === false) {
            this.$store.dispatch('selectDrugInDeviceByPosSelection',
              { deviceId: device.id, drugStorageSet: device.drugstorage_set },
            );
          }
        }
      }
      if (this.mode === 'emptyAndF' && device.specific_type === null && device.error !== true) {
        if (device.drugstorage_set.length === 0) {
          this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', device.id);
        } else if (this.currentNet.type === 'F' && this.singleSelect === false && device.drugstorage_set.length < 24) {
          this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', device.id.toString());
        }
      }
      if (this.mode === 'lockDevice' && device.specific_type === 'lock_device' && device.error !== true && device.drugstorage_set.length === 0) {
        this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', device.id);
      }
    },
    selectDrug(drugStorage) {
      if (this.mode === 'onlyDrug') {
        const targetIndex = _.findIndex(this.$store.state.drugInDevice.drugInDeviceList, (o) => { return o.id === drugStorage.id; });
        this.$store.dispatch('selectDrugInDevice', { num: targetIndex });
        drugStorage.selected = !drugStorage.selected;
      }
    },
    nextSystem() {
      if ((this.systemIndex + 1) < this.systemIds.length) this.systemIndex += 1;
    },
    previousSystem() {
      if (this.systemIndex !== 0) this.systemIndex -= 1;
    },
  },
  filters: {
    reverse(val) {
      return val.slice().reverse();
    },
    setLength(str) {
      if (str.length > 10) return `${str.substring(0, 10)}...`;
      return str;
    },
  },
  watch: {
    // handle device selected.
    selectedDevicesID(val) {
      const targetDevices = this.selectedDevicesID.map((id) => { return this.$store.state.device.allDevices[id]; });
      this.previousSelectedDevicesID.forEach((id) => {
        if (this.selectedDevicesID.indexOf(id) === -1) {
          const cancelDevice = this.$store.state.device.allDevices[id];
          const pdevice = this.allSystems[cancelDevice.net.system_serial].net_set[(cancelDevice.net.row_id - 1)].device_set[cancelDevice.index];
          pdevice.selected = false;
          const pnet = this.allSystems[cancelDevice.net.system_serial].net_set[(cancelDevice.net.row_id - 1)];
          pnet.hasDeviceSelected = false;
        }
      });
      // setup this targets
      targetDevices.forEach((device) => {
        const tdevice = this.allSystems[device.net.system_serial].net_set[(device.net.row_id - 1)].device_set[device.index];
        tdevice.selected = true;
        const tnet = this.allSystems[device.net.system_serial].net_set[(device.net.row_id - 1)];
        tnet.hasDeviceSelected = true;
      });
      // javascript is a pass-by-value language, you must make a copy otherwise you are actually changing the same array.
      this.previousSelectedDevicesID = this.selectedDevicesID.slice();
    },
    // handle drugStorage selected
    selectedDrugInDeviceID(val) {
      const targetDrugStorage = this.selectedDrugInDeviceID.map((id) => { return this.$store.state.drugInDevice.allDrugInDevice[id]; });
      this.previousSelectedDrugStorageID.forEach((drugStorageID) => {
        // the old one was not found in the new one, indicates that it should be unselected.
        if (this.selectedDrugInDeviceID.indexOf(drugStorageID) === -1) {
          const cancelDrugStorage = this.$store.state.drugInDevice.allDrugInDevice[drugStorageID];
          const cancelDevice = this.$store.state.device.allDevices[cancelDrugStorage.device.id];
          const localDevice = this.allSystems[cancelDrugStorage.device.net.system_serial].net_set[(cancelDrugStorage.device.net.row_id - 1)].device_set[cancelDevice.index];

          // once a item is selected, make the device selected.
          let onceDrugStorageInPreviousDeviceSelected = false;
          localDevice.drugstorage_set.forEach((item) => {
            if (item.id === parseInt(drugStorageID, 10)) {
              item.selected = false;
            }
            if (item.selected) {
              onceDrugStorageInPreviousDeviceSelected = true;
            }
          });
          if (onceDrugStorageInPreviousDeviceSelected) {
            localDevice.selected = true;
          } else {
            localDevice.selected = false;
          }
        }
      });

      targetDrugStorage.forEach((drugStorage) => {
        const targetDevice = this.$store.state.device.allDevices[drugStorage.device.id];
        const tlocalDevice = this.allSystems[drugStorage.device.net.system_serial].net_set[(drugStorage.device.net.row_id - 1)].device_set[targetDevice.index];
        let onceDrugStorageInTargetDeviceSelected = false;
        // const tlocalNet = this.allSystems[drugStorage.device.net.system.id].net_set[(drugStorage.device.net.row_id - 1)];
        // tlocalNet.hasDeviceSelected = true;
        tlocalDevice.drugstorage_set.forEach((item) => {
          if (item.id === drugStorage.id) {
            item.selected = true;
          }
          // once a item is selected, make the device selected.
          if (item.selected === true) {
            onceDrugStorageInTargetDeviceSelected = true;
          }
        });
        if (onceDrugStorageInTargetDeviceSelected) {
          tlocalDevice.selected = true;
        } else {
          tlocalDevice.selected = false;
        }
      });

      this.previousSelectedDrugStorageID = this.selectedDrugInDeviceID.slice();
    },
  },
};
</script>

<style lang="sass">
.system-wrapper
  display: flex;

.net-wrap
  width: 100%;

.row-model
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 20
  display: flex;
  align-items: center;
  justify-content: center

.model-mask
  background: rgba(0,0,0,0.3)
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 20
  display: flex

.model-content
  // background-color: white
  // border-radius: 5px
  // min-width: 500px;
  // margin: auto;
  // padding: 40px
  

.row-wrap
  display: flex
  flex-flow: column-reverse
  height: 650px
  // transform: rotateX(53deg) rotateY(0deg) rotateZ(-36deg) translate(0%, 0%) scale3d(1, 1, 1);
  transform-style: preserve-3d;
  background: #EEEEEE
  position: relative
  z-index: 21
  width: fit-content

  .close-button
    width: 30px
    height: 30px
    right: 0px
    top: 0px
    position: absolute
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FF3811;
    color: white;
    cursor: pointer;

.row-info
  position: absolute
  top: 20px
  left: -60px
  color: white
  font-size: 24px
  transform: rotate(90deg)
  // transform: rotateX(53deg) rotateY(0deg) rotateZ(-36deg) translate(0%, 0%) scale3d(1, 1, 1);

.one-net
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0,0,0,0.2);
  min-width: 90px;
  height: 40px
  text-align: center;
  position: relative
  .device-badge
    background-color: cadetblue
    border-radius: 50%
    width: 25px
    height: 25px
    text-align: center
    border: 1px solid cadetblue
    color: black
    position: absolute
    left: 10px
    top: 7px

.btn-select
  position: absolute
  right: 5px
  top: 3px
  font-size: 0.75rem
  background-color: cadetblue
  color: white

.one-system
  width: 400px
  margin: auto


.one-net-row
  display: flex;
  border-collapse: collapse
  width: 840px;
  align-items: center;

.one-device
  height: 95%
  transform: translate3d(0, 0, 4px);
  transform-style: preserve-3d
  border-radius: 2px;
  background: #FAFAFA;
  border-bottom: 2px solid #c7c7c7;
  border-left: 2px solid #c7c7c7;
  display: inline-block;
  // height: 130px
  text-align: center;
  vertical-align: middle;
  position: relative
  overflow: visible;
  margin: 2px
  transition-duration: 0.5s
  transition-timing-function: ease
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  .device-position
    position: absolute
    bottom: 0px
    left: 0px
    border-right: 1px solid rgba(0,0,0,0.2)
    border-bottom: 1px solid rgba(0,0,0,0.2)
    background-color: transparent
    color: rgba(0,0,0,0.4)
    padding: 2px 5px
  &.selected-arise
    .device-position
      background-color: white


.drug-pop
  position: absolute;
  width: 100%;
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  flex-wrap: wrap;
  .device-drug
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    margin-bottom: 0
    border: 1px solid rgba(0,0,0,0.3);
    padding: 12px;
    margin: 10px
    border-radius: 10px;
    color: cadetblue;
    background: white;
    transform: translate3d(0, 0, 4px);
    transform-style: preserve-3d
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
    transition-duration: 0.5s
    transition-timing-function: ease
    &.selected
      background-color: #42b883
      color: white
      border-color: white
      transform: translate3d(0, 0, 8px);
      box-shadow: -12px 10px 9px rgba(0, 0, 0, 0.1), -12px 16px 9px rgba(0, 0, 0, 0.1);

    img
      width: 16px 
      margin: 5px 5px


.system-name
  text-align: center;

.selected-arise
  background-color: cadetblue;
  color: white;
  // transform: translate3d(0, 0, 16px);
  // box-shadow: -6.6px 10px 9px rgba(0, 0, 0, 0.1), -15.6px 26.4px 15px rgba(0, 0, 0, 0.1)

.device-in-F
  width: 100% !important
  height: 95%


.unclicked
  cursor: none

.pos-confirm-button
  margin-top: 30px
  height: 60px
  justify-content: center
  display: flex
  flex-direction: column;

.return-cmpn
  background: repeating-linear-gradient(-45deg, lighten(#FF3811, 10), lighten(#FF3811, 10) 10px, transparent 10px, transparent 20px)
  background-color: rgba(0,0,0,0)
  border: 0px
  color: black
  &.selected
    background: repeating-linear-gradient(-45deg, #FF3811, #FF3811 10px, transparent 10px, transparent 20px)
    color: black

.expired
  background: repeating-linear-gradient(-45deg, #FF3811, #FF3811 10px, transparent 10px, transparent 20px) !important
  background-color: rgba(0,0,0,0) !important
  color: black !important

.btn-system-change
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  top: calc(50% - 15px);
  

#prev-system
  border-width: 15px 20px 15px 0;
  border-color: transparent cadetblue transparent transparent;
  left: 0px
#next-system
  border-width: 15px 0px 15px 20px;
  border-color: transparent transparent transparent cadetblue;
  right: 0px

.cabinet-bottom
  height: 10px
  width: 80px
  border: 1px solid rgba(0, 0, 0, 0.2)
  border-top: 0px
  background-color: rgba(0, 0, 0, 0.2)

.error-device-mask
  width: 100%
  height: 100%
  background-color: rgba(0,0,0,0.2)
  top: 0
  left: 0
  position: absolute
  display: flex
  justify-content: center
  align-items: center
  p
    padding: 10px 10px
    background-color: rgba(255,255,255,0.9)
    border-radius: 10px
    color: red

.lock-cmpn
  border: 2px solid orange
  &.selected-arise
    background-color: orange
.lock-cmpn-full
  background: repeating-linear-gradient(-45deg, orange, orange 10px, transparent 10px, transparent 20px) !important

  
</style>



// WEBPACK FOOTER //
// PositionSelection.vue?aecfdae6